if (!customElements.get('vvr-welcome-offer')) {
  customElements.define('vvr-welcome-offer', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      customElements.whenDefined('pop-in').then(() => {
        if (signal.aborted || !this.isConnected) return;
        const panel = this.querySelector('pop-in');
        const trigger = this.querySelector('.vvr-welcome-offer__trigger');
        const closeButton = panel?.querySelector('dialog-close-button button');
        const form = panel?.querySelector('form');
        if (!panel || !trigger || !form) return;

        panel.addEventListener('dialog:after-show', () => {
          closeButton?.focus({ preventScroll: true });
          this.dispatchEvent(new CustomEvent('vvr:newsletter-open', {
            bubbles: true, detail: { placement: 'header', locale: document.documentElement.lang }
          }));
        }, { signal });
        panel.addEventListener('dialog:after-hide', () => trigger.focus({ preventScroll: true }), { signal });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && panel.open) {
            event.preventDefault();
            panel.hide();
          }
        }, { signal });

        const returnedToThisForm = location.hash === `#${form.id}`;
        if (returnedToThisForm && panel.querySelector('[data-welcome-success], [data-welcome-error]')) {
          panel.show(false);
        }
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
